export const appNavigationGroups = [
  {
    key: 'principal',
    label: 'Principal',
    items: [
      {
        key: 'inicio',
        label: 'Inicio',
        icon: 'home',
        to: '/inicio',
        matchers: ['/inicio'],
        title: 'Inicio',
        description: 'Vista general para entrar rápido a stock, alertas y canales.',
      },
      {
        key: 'stock',
        label: 'Stock',
        icon: 'cubes',
        to: '/stock',
        matchers: ['/stock', '/home'],
        title: 'Stock',
        description: 'Gestioná SKU, stock y publicaciones existentes.',
      },
      {
        key: 'diferencias',
        label: 'Alertas de stock',
        icon: 'warning sign',
        to: '/stock-inconsistencies',
        matchers: ['/stock-inconsistencies'],
        title: 'Alertas de stock',
        description: 'Resolvé los casos que impiden que tu stock quede sincronizado.',
        badgeKey: 'totalOpen',
      },
      {
        key: 'precios',
        label: 'Precios',
        icon: 'dollar',
        to: '/precios',
        matchers: ['/precios'],
        title: 'Precios',
        description: 'Actualizá precios masivos e importá costos y listas.',
      },
    ],
  },
  {
    key: 'operacion',
    label: 'Reportes',
    items: [
      {
        key: 'movimientos',
        label: 'Movimientos',
        icon: 'exchange',
        to: '/movimientos',
        matchers: ['/movimientos', '/stock-movements'],
        title: 'Movimientos',
        description: 'Historial de cambios de stock y sincronizaciones entre canales',
      },
      {
        key: 'ordenes',
        label: 'Órdenes',
        icon: 'shopping cart',
        to: '/ordenes',
        matchers: ['/ordenes', '/orders'],
        title: 'Órdenes',
        description: '',
        badgeKey: 'unreadOrders',
      },
    ],
  },
  {
    key: 'gestion',
    label: 'Gestión',
    items: [
      {
        key: 'canales',
        label: 'Canales',
        icon: 'plug',
        to: '/canales',
        matchers: ['/canales', '/newAccount', '/notifications'],
        title: 'Canales',
        description: 'Conectá cuentas, importá publicaciones y buscá novedades.',
        children: [
          {
            key: 'canales-importar',
            label: 'Importar cuenta',
            to: '/newAccount',
            matchers: ['/newAccount'],
          },
          {
            key: 'canales-nuevas',
            label: 'Buscar publicaciones nuevas',
            to: '/notifications',
            matchers: ['/notifications'],
          },
        ],
      },
    ],
  },
];

export function isPathMatch(pathname, candidatePaths = []) {
  return candidatePaths.some((candidate) => pathname === candidate || pathname.startsWith(`${candidate}/`));
}

export function resolveActiveNavKey(pathname, isAdmin) {
  for (const group of appNavigationGroups) {
    for (const item of group.items) {
      if (item.key === 'configuracion' && !isAdmin) {
        continue;
      }
      if (isPathMatch(pathname, item.matchers || [item.to])) {
        return item.key;
      }
      if (Array.isArray(item.children)) {
        const matchedChild = item.children.find((child) => isPathMatch(pathname, child.matchers || [child.to]));
        if (matchedChild) {
          return item.key;
        }
      }
    }
  }

  if (pathname === '/users') {
    return isAdmin ? 'configuracion' : 'stock';
  }

  if (pathname === '/feature-flags') {
    return isAdmin ? 'feature-flags' : 'stock';
  }

  return 'stock';
}

export function getVisibleNavigation(isAdmin, options = {}) {
  const { showPrices = false } = options;
  return appNavigationGroups.map((group) => {
    const items = [...group.items].filter((item) => {
      if (item.key === 'precios') {
        return showPrices;
      }
      return true;
    });
    if (group.key === 'gestion' && isAdmin) {
      items.push({
        key: 'configuracion',
        label: 'Configuración',
        icon: 'settings',
        to: '/users',
        matchers: ['/users'],
        title: 'Configuración',
        description: 'Administrá usuarios y herramientas internas.',
      });
      items.push({
        key: 'feature-flags',
        label: 'Feature flags',
        icon: 'toggle on',
        to: '/feature-flags',
        matchers: ['/feature-flags'],
        title: 'Feature flags',
        description: 'Configurá módulos, sus precios y a qué usuarios se los activás.',
      });
    }
    return {
      ...group,
      items,
    };
  });
}

export function resolvePageMeta(pathname, isAdmin) {
  const visibleNavigation = getVisibleNavigation(isAdmin, { showPrices: true });
  for (const group of visibleNavigation) {
    for (const item of group.items) {
      if (isPathMatch(pathname, item.matchers || [item.to])) {
        return {
          title: item.title || item.label,
          description: item.description || '',
        };
      }
      if (Array.isArray(item.children)) {
        const matchedChild = item.children.find((child) => isPathMatch(pathname, child.matchers || [child.to]));
        if (matchedChild) {
          return {
            title: matchedChild.label,
            description: item.description || '',
          };
        }
      }
    }
  }

  return {
    title: 'MercuryCom',
    description: 'Centro operativo de stock y publicaciones.',
  };
}
